import { Action } from 'redux';
import LoanPaymentAbasActionsEnum from './ActionsEnum';
import ILoanPaymentAba from '~Api/LoanPaymentAba/ILoanPaymentAba';
import ILoanPaymentAbaHistory from '~Api/LoanPaymentAba/ILoanPaymentAbaHistory';
import IWarehouseLoanTransaction from '~Api/Warehouse/IWarehouseLoanTransaction';

export interface ILoanPaymentAbasAddAction extends Action {
    warehouseLoanTransactionUuids: string[];
}

export function loanPaymentAbasAddAction(warehouseLoanTransactionUuids: string[]): ILoanPaymentAbasAddAction {
    return {
        type: LoanPaymentAbasActionsEnum.LoanPaymentAbasAdd,
        warehouseLoanTransactionUuids,
    };
}

export type ILoanPaymentAbasListAction = Action<LoanPaymentAbasActionsEnum.LoanPaymentAbasList>;

export function loanPaymentAbasListAction(): ILoanPaymentAbasListAction {
    return {
        type: LoanPaymentAbasActionsEnum.LoanPaymentAbasList,
    };
}

export interface ILoanPaymentAbasSetAction extends Action {
    loanPaymentAbas: ILoanPaymentAba[];
}

export function loanPaymentAbasSetAction(loanPaymentAbas: ILoanPaymentAba[]): ILoanPaymentAbasSetAction {
    return {
        loanPaymentAbas,
        type: LoanPaymentAbasActionsEnum.LoanPaymentAbasSet,
    };
}

export interface ILoanPaymentAbaGetAction extends Action {
    loanPaymentAbaUuid: string;
}

export function loanPaymentAbaGetAction(loanPaymentAbaUuid: string): ILoanPaymentAbaGetAction {
    return {
        loanPaymentAbaUuid,
        type: LoanPaymentAbasActionsEnum.LoanPaymentAbaGet,
    };
}

export interface ILoanPaymentAbaSetAction extends Action {
    loanPaymentAba: ILoanPaymentAba;
}

export function loanPaymentAbaSetAction(loanPaymentAba: ILoanPaymentAba): ILoanPaymentAbaSetAction {
    return {
        loanPaymentAba,
        type: LoanPaymentAbasActionsEnum.LoanPaymentAbaSet,
    };
}

export interface ILoanPaymentAbaHistoriesSetAction extends Action {
    histories: ILoanPaymentAbaHistory[];
    loanPaymentAbaUuid: string;
}

export function loanPaymentAbaHistoriesSetAction(loanPaymentAbaUuid: string, histories: ILoanPaymentAbaHistory[]): ILoanPaymentAbaHistoriesSetAction {
    return {
        histories,
        loanPaymentAbaUuid,
        type: LoanPaymentAbasActionsEnum.LoanPaymentAbaHistoriesSet,
    };
}

export interface ILoanPaymentAbaHistoriesListAction extends Action {
    loanPaymentAbaUuid: string;
}

export function loanPaymentAbaHistoriesListAction(loanPaymentAbaUuid: string): ILoanPaymentAbaHistoriesListAction {
    return {
        loanPaymentAbaUuid,
        type: LoanPaymentAbasActionsEnum.LoanPaymentAbaHistoriesList,
    };
}

export interface ILoanPaymentAbaWarehouseLoanTransactionsSetAction extends Action {
    loanPaymentAbaUuid: string;
    transactions: IWarehouseLoanTransaction[];
}

export function loanPaymentAbaWarehouseLoanTransactionsSetAction(loanPaymentAbaUuid: string, transactions: IWarehouseLoanTransaction[]): ILoanPaymentAbaWarehouseLoanTransactionsSetAction {
    return {
        loanPaymentAbaUuid,
        transactions,
        type: LoanPaymentAbasActionsEnum.LoanPaymentAbaWarehouseLoanTransactionsSet,
    };
}

export interface ILoanPaymentAbaWarehouseLoanTransactionsListAction extends Action {
    loanPaymentAbaUuid: string;
}

export function loanPaymentAbaWarehouseLoanTransactionsListAction(loanPaymentAbaUuid: string): ILoanPaymentAbaWarehouseLoanTransactionsListAction {
    return {
        loanPaymentAbaUuid,
        type: LoanPaymentAbasActionsEnum.LoanPaymentAbaWarehouseLoanTransactionsList,
    };
}

export type ILoanPaymentAbasUnallocatedWarehouseLoanTransactionsClearAction = Action<LoanPaymentAbasActionsEnum.LoanPaymentAbasUnallocatedWarehouseLoanTransactionsClear>;

export function loanPaymentAbasUnallocatedWarehouseLoanTransactionsClearAction(): ILoanPaymentAbasUnallocatedWarehouseLoanTransactionsClearAction {
    return {
        type: LoanPaymentAbasActionsEnum.LoanPaymentAbasUnallocatedWarehouseLoanTransactionsClear,
    };
}

export type ILoanPaymentAbasUnallocatedWarehouseLoanTransactionsListAction = Action<LoanPaymentAbasActionsEnum.LoanPaymentAbasUnallocatedWarehouseLoanTransactionsList>;

export function loanPaymentAbasUnallocatedWarehouseLoanTransactionsListAction(): ILoanPaymentAbasUnallocatedWarehouseLoanTransactionsListAction {
    return {
        type: LoanPaymentAbasActionsEnum.LoanPaymentAbasUnallocatedWarehouseLoanTransactionsList,
    };
}

export interface ILoanPaymentAbasUnallocatedWarehouseLoanTransactionsSetAction extends Action {
    transactions: IWarehouseLoanTransaction[];
}

export function loanPaymentAbasUnallocatedWarehouseLoanTransactionsSetAction(transactions: IWarehouseLoanTransaction[]): ILoanPaymentAbasUnallocatedWarehouseLoanTransactionsSetAction {
    return {
        transactions,
        type: LoanPaymentAbasActionsEnum.LoanPaymentAbasUnallocatedWarehouseLoanTransactionsSet,
    };
}

